/** @format */

// Centralized Auth utilities - consolidated authentication logic

export type { JWTPayload } from "../lib/authUtils";
export {
  decodeJWT,
  isTokenExpired,
  getTokenExpiryTime,
  clearAuthData,
  clearTokens,
  setTokens,
  getAccessToken,
  getRefreshToken,
  isAuthenticated,
  setUserData,
  getUserData,
  rememberMeUtils,
  sanitizeInput,
  isValidEmail,
  getAuthStorageKeys,
  getAuthStorageDetails,
} from "../lib/authUtils";

// Import the functions we need for our utilities
import { clearAuthData, isValidEmail, sanitizeInput } from "../lib/authUtils";

export const loginValidation = {
  /**
   * Validate login form data
   */
  validateLoginForm(
    email: string,
    password: string
  ): { isValid: boolean; errors: Record<string, string> } {
    const errors: Record<string, string> = {};

    // Email validation
    if (!email.trim()) {
      errors.email = "Email is required";
    } else if (!isValidEmail(email)) {
      errors.email = "Please enter a valid email address";
    }

    // Password validation
    if (!password.trim()) {
      errors.password = "Password is required";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
    };
  },

  /**
   * Sanitize login form data
   */
  sanitizeLoginData(email: string, password: string) {
    return {
      email: sanitizeInput(email.trim().toLowerCase()),
      password: password.trim(),
    };
  },
};

/**
 * Simple auth state utilities
 */
export const authStateUtils = {
  /**
   * Clear all auth data - simplified version
   */
  clearAllAuthData() {
    clearAuthData();
  },
};
